import React from 'react'
import classnames from 'classnames'
import styles from './Button.module.scss'

export interface ButtonProps extends React.ComponentPropsWithRef<'button'> {
  type?: 'submit' | 'button' | 'reset' | undefined
  regular?: boolean
  primary?: boolean
  secondary?: boolean
  editable?: boolean
  minimal?: boolean
  wide?: boolean
  fullWidth?: boolean
  className?: string
  children?: React.ReactNode
  onClick?: (args) => void
  loading?: boolean
  disabled?: boolean
  iconEnd?: React.ElementType
  iconStart?: React.ElementType
}

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  (
    {
      regular,
      primary,
      secondary,
      minimal,
      editable,
      wide,
      fullWidth,
      className,
      children,
      onClick,
      loading,
      disabled,
      iconStart: IconStart,
      iconEnd: IconEnd,
      type,
      ...restProps
    },
    ref
  ) => {
    return (
      <button
        className={classnames(
          styles.button,
          regular && styles.regular,
          primary && styles.primary,
          secondary && styles.secondary,
          minimal && styles.minimal,
          editable && styles.editable,
          wide && styles.wide,
          fullWidth && styles.fullWidth,
          loading && styles.loading,
          (IconEnd || IconStart) && !children && styles.iconOnly,
          className
        )}
        disabled={loading || disabled}
        ref={ref}
        onClick={onClick}
        type={type}
        {...restProps}
      >
        {!loading && !!IconStart && <IconStart className={styles.iconStart} />}
        <div
          className={classnames(
            styles.buttonChild,
            editable && styles.editableChildren
          )}
        >
          {children}
        </div>
        {!loading && !!IconEnd && <IconEnd className={styles.iconEnd} />}
      </button>
    )
  }
)

export default Button
